import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  IGenericServiceResponse,
  IServiceResponse,
} from '../interfaces/IServiceResponse';
import { environment } from 'src/environments/environment';
import { EpisodeOfCareService } from './episodeOfCare.service';
import { PatientService } from './patient.service';
import { IGlucoseDetailed } from '../interfaces/Glucose/IGlucoseDetailed';
import { IAddGlucose } from '../interfaces/Glucose/IAddGlucose';
import { TranslateService } from '@ngx-translate/core';
import { SwalToastService } from './swal.service';

@Injectable({ providedIn: 'root' })
export class GlucoseService {
  public glucoseModalSub = new BehaviorSubject<boolean>(false);

  public glucoseEditSub = new BehaviorSubject<IGlucoseDetailed | undefined>(
    undefined
  );

  public glucoseDataSub = new BehaviorSubject<IGlucoseDetailed[]>([]);

  public glucoseLoadingSub = new BehaviorSubject<boolean>(false);
  public glucoseLoadingSub$ = this.glucoseLoadingSub.asObservable();

  constructor(
    private readonly _http: HttpClient,
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService
  ) {}

  async getData() {
    this.glucoseLoadingSub.next(true);
    this.getGlucose(
      this.patientService.patientIDsignal(),
      this.eocService.currentEocId(),
      this.eocService.currentVisitId()
    ).subscribe({
      next: (response) => {
        this.glucoseDataSub.next(response?.data!);
        this.glucoseLoadingSub.next(false);
      },
      error: (err) => {
        this.swalToastService.toastError('Unable to retrieve Glucose data');
        console.error('Error fetching Glucose data:', err);
      },
    });
  }

  getGlucose(
    patientId: string,
    episodeCareId: string,
    visitId?: string
  ): Observable<IGenericServiceResponse<IGlucoseDetailed[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this._http.get<IGenericServiceResponse<IGlucoseDetailed[]>>(
      `${environment.BACKEND_URL}Glucose/${patientId}/${episodeCareId}?visitId=${visitId}`,
      {
        headers: headers,
      }
    );
  }

  addGlucose(abgObj: IAddGlucose) {
    abgObj.visitId = this.eocService.currentVisitId();
    abgObj.patientId = this.patientService.patientIDsignal();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.post(`${environment.BACKEND_URL}Glucose`, abgObj, {
      headers: headers,
    });
  }

  editGlucose(abgObj: IAddGlucose) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.put(
      `${environment.BACKEND_URL}Glucose/${abgObj.id}`,
      abgObj,
      {
        headers: headers,
      }
    );
  }

  deleteGlucose(medicalAlertId: string): Observable<IServiceResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.delete<IServiceResponse>(
      `${environment.BACKEND_URL}Glucose/${medicalAlertId}`,
      {
        headers: headers,
      }
    );
  }

  deleteGlucoseFromTable(glucoseId: string) {
    // REMOVE THE Glucose record
    this.glucoseDataSub.next(
      this.glucoseDataSub.value?.filter(
        (abg) => abg.id?.toString() != glucoseId
      )
    );
  }
}
